import { jsx } from 'panel';
import { InputEl } from 'common/components/input';
import { getAlphaLabelFromIndex, parseNumber } from 'common/util';
import { RowFilters } from 'common/widgets/query-entry-section/components/filters';
import { RowSelector } from 'common/widgets/query-entry-section/components/selector';
import { EntryPart } from 'common/widgets/query-entry-section/types';
import { BaseEntryRowEl } from '../base/template';
/**
 * FlowsEntryRow is specific to the flows report where forward and reverse steps
 * are represented in the query builder.
 */

export function FlowsEntryRowEl(_ref) {
  let {
    section,
    entry,
    index
  } = _ref;

  var _a, _b, _c, _d;

  const forwardSteps = (_b = (_a = entry.forward) === null || _a === void 0 ? void 0 : _a.toString(10)) !== null && _b !== void 0 ? _b : "0";
  const reverseSteps = (_d = (_c = entry.reverse) === null || _c === void 0 ? void 0 : _c.toString(10)) !== null && _d !== void 0 ? _d : "0";

  const selectorRenderer = () => jsx(null, null, jsx(RowSelector, {
    el: section,
    entry: entry,
    index: index,
    isPlaceholder: !this.hasEventValue()
  }));

  const bodyRowRenderer = () => jsx(null, null, jsx("div", {
    sel: '.mp-query-entry-row.for-filters'
  }, jsx(RowFilters, {
    el: section,
    entry: entry,
    index: index,
    source: EntryPart.Filters,
    handleUpdate: ev => this.handleFilterSectionUpdate(ev, EntryPart.Filters)
  }), jsx(RowFilters, {
    el: section,
    entry: entry,
    index: index,
    source: EntryPart.BehavioralFilters,
    handleUpdate: ev => this.handleFilterSectionUpdate(ev, EntryPart.BehavioralFilters)
  })));

  const prefixRenderer = entry.event.value ? () => jsx(null, null, jsx("div", {
    sel: '.mp-query-entry-prefix'
  }, jsx(InputEl, {
    key: "reverse-step-input-".concat(index),
    attrs: {
      elref: "reverseStepInput",
      type: "number",
      'select-on-focus': true
    },
    props: {
      value: reverseSteps
    },
    on: {
      change: ev => {
        // when the upadted value is not a valid input, revert back to previously committed input
        const updatedValue = parseNumber(ev.detail.value);

        if (updatedValue !== null && updatedValue >= 0 && updatedValue <= 99) {
          this.handleReverseStepsUpdate(updatedValue);
        } else {
          ev.target.value = reverseSteps;
        }
      }
    }
  }), jsx("div", {
    sel: '.text'
  }, "steps before"), jsx("div", {
    sel: '.label'
  }, getAlphaLabelFromIndex(index)))) : null;
  const suffixRenderer = entry.event.value ? () => jsx(null, null, jsx("div", {
    sel: '.mp-query-entry-suffix'
  }, jsx(InputEl, {
    key: "forward-step-input-".concat(index),
    attrs: {
      elref: "forwardStepInput",
      type: "number",
      placeholder: "value",
      'select-on-focus': true
    },
    props: {
      value: forwardSteps
    },
    on: {
      change: ev => {
        // when the upadted value is not a valid input, revert back to previously committed input
        const updatedValue = parseNumber(ev.detail.value);

        if (updatedValue !== null && updatedValue >= 0 && updatedValue <= 99) {
          this.handleForwardStepsUpdate(updatedValue);
        } else {
          ev.target.value = forwardSteps;
        }
      }
    }
  }), jsx("div", {
    sel: '.text'
  }, "steps after"), jsx("div", {
    sel: '.label'
  }, getAlphaLabelFromIndex(index)))) : null;
  return jsx(BaseEntryRowEl, {
    index: index,
    el: section,
    entry: entry,
    rowRenderer: {
      prefixRenderer,
      selectorRenderer,
      bodyRowRenderer,
      suffixRenderer
    },
    isPlaceholder: this.isPlaceholder()
  });
}